import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';
import {denim} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  headerText: {
    ...getFontFamily('bold'),
  },
  order: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  orderColumn1: {
    flex: 1,
  },
  orderLine: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  orderDate: {
    flex: 1,
  },
  orderAmount: {
    flex: 0,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  orderAmountEmptyText: {
    ...getFontFamily('bold'),
  },
  orderColumn2: {
    justifyContent: 'center',
  },
  orderNumberContainer: {
    marginTop: indent * 0.2,
  },
  arrowIcon: {
    paddingLeft: indent,
  },
  orderNumber: {
    color: denim,
  },
});
